var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadEPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 346.21,
    height: 469.79,
    viewBox: "0 0 346.21 469.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #414042;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #020202;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.09,10.11v99.23c.16,1.87,1.31,12.69,14,20.65,12.58,7.86,27.06,7.06,29.65,6.88h85.83",
    transform: "translate(-14.39 -10.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.54,479.89V380.66c-.16-1.87-1.34-12.69-14.43-20.65-12.93-7.86-27.82-7.06-30.48-6.88H14.39",
    transform: "translate(-14.39 -10.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.61,179.9H277.12c-3.27-.08-18.35-.15-31.2,8.31-14.42,9.49-14.81,22.32-14.83,24.38v267.3",
    transform: "translate(-14.39 -10.11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.39,310.1h85.83c3.37.08,18.87.15,32.08-8.31,14.82-9.49,15.23-22.32,15.24-24.38V10.11",
    transform: "translate(-14.39 -10.11)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,333.89H15.14a.67.67,0,0,1-.74-.62.69.69,0,0,1,.58-.79H30a.71.71,0,0,1,.16,1.41Z",
    transform: "translate(-14.39 -10.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.6,333.68l-6.44,6.89a.62.62,0,0,1-.93,0,.76.76,0,0,1,0-1l6-6.39-6-6.34a.76.76,0,0,1,0-1,.74.74,0,0,1,.47-.2.65.65,0,0,1,.45.2l6.44,6.89A.77.77,0,0,1,30.6,333.68Z",
    transform: "translate(-14.39 -10.11)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.43,160.79h14.46a.65.65,0,0,0,.71-.62.7.7,0,0,0-.56-.79H345.43a.67.67,0,0,0-.72.63.69.69,0,0,0,.56.78A.43.43,0,0,0,345.43,160.79Z",
    transform: "translate(-14.39 -10.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.85,160.58l6.25,6.89a.6.6,0,0,0,.91,0,.76.76,0,0,0,0-1l-5.8-6.39,5.79-6.34a.76.76,0,0,0,0-1,.69.69,0,0,0-.45-.2.65.65,0,0,0-.45.2l-6.25,6.89A.74.74,0,0,0,344.85,160.58Z",
    transform: "translate(-14.39 -10.11)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.38,463.18V479.1a.7.7,0,0,1-.57.79.66.66,0,0,1-.71-.62.49.49,0,0,1,0-.17V463.18a.7.7,0,0,1,.56-.79.66.66,0,0,1,.72.62Z",
    transform: "translate(-14.39 -10.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.19,462.54l6.26,6.89a.78.78,0,0,1,0,1,.61.61,0,0,1-.91,0L217.73,464,212,470.42a.61.61,0,0,1-.91,0,.75.75,0,0,1-.18-.5.72.72,0,0,1,.18-.49l6.25-6.89A.62.62,0,0,1,218.19,462.54Z",
    transform: "translate(-14.39 -10.11)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.93,26.82V10.9a.69.69,0,0,0-.58-.79.67.67,0,0,0-.73.62.49.49,0,0,0,0,.17V26.82a.69.69,0,0,0,.58.79.66.66,0,0,0,.73-.62A.49.49,0,0,0,166.93,26.82Z",
    transform: "translate(-14.39 -10.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.74,27.46l6.43-6.89a.74.74,0,0,0,0-1,.64.64,0,0,0-.93,0l-6,6.39-5.92-6.38a.64.64,0,0,0-.93,0,.76.76,0,0,0-.19.5.73.73,0,0,0,.19.49l6.43,6.89A.64.64,0,0,0,166.74,27.46Z",
    transform: "translate(-14.39 -10.11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadEPhoto);
export default __webpack_public_path__ + "static/media/road-E-photo.7e44193a9aeaa1dc07cfd508f0883f2c.svg";
export { ForwardRef as ReactComponent };